import Axios from 'axios';

export default {

    getEventBetTypes(sportId) {
        return Axios.get(`/api/liveinplay/${sportId}/bettypecategories`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                this.error = error;
            })
    }
}